import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ApplicationModulesIds } from '../../../app/module-registry/application-modules';
import { FragmentNames, PseudonymAppointmentsConfirmationDetailAliases } from '../../../codegen';
import PseudonymAppointmentsBaseController from '../pseudonym-appointments-base-controller';

@Controller({ fragment: FragmentNames.PSEUDONYM_APPOINTMENTS_CONFIRMATION_DETAIL })
export default class PseudonymAppointmentsConfirmationDetailController extends PseudonymAppointmentsBaseController {

  @OnMount({ target: PseudonymAppointmentsConfirmationDetailAliases.LAYOUT_DETAIL })
  handleOnMountLayoutDetail(): void {
    const event = new CustomEvent('updateModulesRoute', { detail: { moduleId: ApplicationModulesIds.APPOINTMENTS } });
    dispatchEvent(event);
  }

}
